var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canShow)?_c('ul',_vm._l((_vm.menus),function(item,index){return _c(_vm.resolveNavItemComponent(item),{key:index,tag:"component",attrs:{"item":item}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }